// extracted by mini-css-extract-plugin
export default {"buttonLoaderWrapper":"Login_buttonLoaderWrapper__zBt8m"};